var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Banner_Component'),_c('RentalBoxOnHand_Component'),_c('Footer_Compontent'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }